<template>
    <div>
        <div class="top-title">
            <h3>{{ $t("message.answers") }}</h3>
        </div>
        <div class="modal-tasks-itle">
            <el-form ref="form" :model="form" :rules="rules" label-position="top">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-form-item
                            :label="$t('message.full_name')"
                            prop="full_name"
                            class="label_mini"
                        >
                            <crm-input
                                :size="'medium'"
                                :inputValue="form.full_name"
                                v-model="form.full_name"
                                :placeholder="$t('message.full_name')"
                            ></crm-input>
                        </el-form-item>
                    </el-col>
                    <!-- end col -->
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-form-item
                            :label="$t('message.type')"
                            prop="type_id"
                            class="label_mini"
                        >
                            <select-client-type
                                :size="'medium'"
                                :placeholder="columns.type_id.title"
                                :id="form.type_id"
                                v-model="form.type_id"
                            >
                            </select-client-type>
                        </el-form-item>
                    </el-col>
                    <!-- end col -->
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <crm-phone-input
                            :inputValue="form.phone"
                            v-model="form.phone"
                            @getPhoneStatus="getPhoneStatus"
                            :form_prop="'phone'"
                            :country_code="form.phone_country_code"
                        ></crm-phone-input>
                    </el-col>
                    <!-- end col -->

                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-form-item :label="$t('message.status')">
                            <el-checkbox v-model="form.has_client" :label="$t('message.client')" border></el-checkbox>
                            <el-checkbox v-model="form.has_provider" :label="$t('message.provider')" border></el-checkbox>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
            <el-row>
                <el-button
                    v-loading="onSave"
                    class="mt-5"
                    type="success"
                    @click="submit()"
                >{{ $t(`message.save`) }}</el-button>
            </el-row>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppModal from "@/views/deals/components/add-modal";
import form from "@/utils/mixins/form";
import clients from "@/utils/mixins/models/clients";

export default {
    components: {
        AppModal
    },
    props: ['phone'],
    mixins: [form, clients],
    data() {
        return {
            selectedDeal: null,
            board_id: null,
            dealCreate: false,
            drawerDealCreate: false,
            answers: [],
            questions: [],
            onSave: false,
        };
    },
    created() {
    },
    computed: {
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            save: "clients/store",
        }),
        async afterOpen(){
            console.log(this.phone)
            this.form.phone = this.phone;
        },
        addModalEdit(deal, dealCreate) {
            this.$emit('addModalEdit', {deal, dealCreate})
        },
        submit(){
            let formData = new FormData();
            console.log(this.form.phone)
            for (const key in this.form) {
                if (this.form[key]) {
                    formData.append(key, this.form[key]);
                } else {
                    formData.append(key, "");
                }
            }

            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if(this.is_phone_valid){
                        this.loadingButton = true;
                        this.save(formData)
                            .then((res) => {
                                this.loadingButton = false;
                                this.$alert(res);

                                this.$parent.openQuestionaryModal();
                                if (close) this.close();
                            })
                            .catch((err) => {
                                this.loadingButton = false;
                                this.$alert(err);
                            });
                    }
                    else{
                        this.$notify({
                            title: this.$t('message.validation'),
                            type: "error",
                            offset: 130,
                            message: this.$t('message.phone_number_is_not_valid')
                        });
                    }
                }
            });
        }
    },
};
</script>

<style>

.coloa3 {
    background: #ff3f3f;
}

</style>
